<template>
    <div>
        <div class="card-header window-header">
            <div class="col-12 d-flex justify-content-start">
                <h3>Project #{{ editItem.id }}</h3>
                <button type="button"
                    class="btn btn-success btn-sm"
                    style="height: 30px;margin-left: 10px; padding: 2px 5px;line-height: 1;"
                    @click="editProjectMap()"
                    :disabled="isExistSlug"
                >
                    Save
                </button>
            </div>
        </div>
        <form @submit.prevent="editProjectMap()" id="form1" class="window-body">
            <div v-show="isLoading" class="bgLoaging">
                <Loader :getProgress="apiProgess"></Loader>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <label class="col-form-label">Paste the code HTML of your map here, 
                            <a href="https://maps.google.com/" target="_blank">or get one</a>
                        </label>
                        <div class="input-group" style="padding:0px;">
                            <input type="text" class="form-control" v-model="urlMap"
                            required placeholder="https://www.google.com/maps/embed?pb="
                            style="font-size: 14px;height: 35px;"/>
                            <span class="input-group-text"
                                style="cursor:pointer;"
                                @click="urlMap=null"
                            >Clear</span>
                        </div>
                        <div class="col-md-12">
                            <iframe class="widget_elemt_iframe_map"
                                :src="previewUrl"
                                frameborder="0"
                                allowfullscreen
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-center">
                <button type="submit"
                    class="btn btn-success"
                    style="width: 100%;"
                    :disabled="isExistSlug">Save Project</button>
            </div>
        </form>
    </div>
</template>
<script>
// @ts-ignore
import Loader from "@/core/components/shared/Loader.vue";
export default {
    components: {
        Loader,
    },
    props: {
        dataModal: {
            type: [Object, String, Number, Array],
            require: false,
            default: null,
        }
    },
    data() {
        return {
            isLoading: false,
            isExistSlug: true,
            apis: null,
            urlDefault: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1517337.2149921788!2d-73.00297119894064!3d42.03140120496237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3656de973bffd%3A0x45c6d03655830d1c!2sMassachusetts%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sco!4v1702055332819!5m2!1sen-419!2sus",
            previewUrl: null,
            urlMap: null,
            premiumProfile: false,
            planActual: 1,
            editItem: null,
            apiProgess: 0,
            errorUrl: null,
        };
    },
    created() {
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.Projects;
        // valid premium planID
        this.premiumProfile = (this.$store.getters['core/apps/getPlanIdApp']!=8);
        this.planActual = this.$store.getters['core/apps/getPlanIdApp'];
        if(this.planActual==7){
            this.premiumProfile = true;
            console.log('Plan sponsored, dando permiso de premium', this.premiumProfile);
        }
        console.log('premiumProfile', this.premiumProfile);
        if(this.dataModal!=null){
            this.editItem = this.dataModal;
            // console.log('edit item', this.editItem);
            this.getProjectOpts();
        }
    },
    methods: {
        getProjectOpts(){
            let t = this;
            t.isLoading = true;
            t.urlMap= null;
            let urlService = t.apis.get(7); // getWithMap
            // @ts-ignore
            window.master.post(urlService, {
                user_id: window.master_client,
                org_id: window.localorgdata,
                id: t.editItem.id,
                pusher_id: pusher.connection.socket_id,
            }, {
                onUploadProgress: (progressEvent) => {
                    // console.log('onUploadProgress', progressEvent)
                    let scanPer = Math.floor(
                        (progressEvent.loaded*100 / progressEvent.total)
                    );
                    // console.log('scanPer', scanPer);
                    if(scanPer < 99){
                        t.apiProgess = scanPer;
                    }
                }
            })
            .then((response) => {
                t.apiProgess =100;
                // @ts-ignore
                // console.log(urlService, response.data);
                if(response.data.map){
                    t.urlMap = response.data.map.meta_value;
                }else{
                    t.validUrlMap();
                }
                t.isLoading = false;
            }).catch((error) => {
                console.log(error);
                t.apiProgess =0;
                t.isLoading = false;
                t.validUrlMap();
            });
        },
        editProjectMap(){
            let t = this;
            if(!t.isExistSlug){
                t.isLoading = true;
                let payLoad = new FormData();
                // @ts-ignore
                payLoad.append("user_id", window.master_client);
                // @ts-ignore
                payLoad.append("org_id", window.localorgdata);
                // @ts-ignore
                // eslint-disable-next-line no-undef
                payLoad.append("pusher_id", pusher.connection.socket_id);
                payLoad.append("project_id", t.editItem.id);
                payLoad.append("meta_name", 'map');
                payLoad.append("meta_value", t.urlMap);
                let urlService = t.apis.set(3); // setOpts
                console.log(urlService)
                // @ts-ignore
                window.master.post(urlService, payLoad, {
                    headers: {
                        common: {
                        // @ts-ignore
                        Authorization: 'Bearer ' + window.localtoken_M
                        },
                        post: { 'Content-Type': 'multipart/form-data' }
                    },
                    onUploadProgress: (progressEvent) => {
                        // console.log('onUploadProgress', progressEvent)
                        let scanPer = Math.floor(
                            (progressEvent.loaded*100 / progressEvent.total)
                        );
                        // console.log('scanPer', scanPer);
                        if(scanPer < 99){
                            t.apiProgess = scanPer;
                        }
                    }
                })
                .then((response) => {
                    t.apiProgess =100;
                    // @ts-ignore
                    console.log(urlService, response.data);
                    if(response.data.status){
                        t.$emit('actionReturn', {action: 'refreshList'});
                    }else{
                        t.$notify({
                            group: "noti",
                            type: 'error',
                            title: "Fail!",
                            text: "Could not be saved",
                        });
                    }
                    t.isLoading = false;
                }).catch((error) => {
                    console.log(error);
                    t.apiProgess =0;
                    t.isLoading = false;
                });
            }
        },
        validUrlMap(){
            let t = this;
            let url = this.urlDefault;
            if(this.urlMap!=null && this.urlMap.length){
                url = this.urlMap;
                this.isExistSlug=false;
                let iframe = url.split(' ');
                for (const i in iframe) {
                    if (iframe[i].indexOf('src="')>-1){
                        this.previewUrl= iframe[i].slice(5, iframe[i].length-1);
                    }
                }
            }else{
                this.isExistSlug=true;
                this.previewUrl= url;
            }
            console.log('previewUrl', this.previewUrl)
        },
    },
    watch: {
        "urlMap": function(){
            this.validUrlMap();
        }
    },
};
</script>

<style lang="scss" scoped>
.window-header{cursor: move;padding: 2px;}
.marginTop{margin-top: 20px;}
.window-body{
    height: calc(100vh - 50px);
    // height: 600px;
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: 0em;
    width: 100%;
    .card-body{padding-top: 0px;}
    &::-webkit-scrollbar:vertical {
        width:3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #797979;
        border-radius: 20px;
        border: 0px solid #f1f2f3;
    }
    .bgLoaging {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9;
        background-color: rgba(255, 255, 255, 0.342);
    }

    .bgLoaging>div {
        margin-left: -100px;
    }
    .widget_elemt_iframe_map{
        width: 100%;
        height: 500px;
        margin-top: 20px;
        margin-left: 0px;
        margin-right: 0px;
    }
    .card-footer.d-flex.justify-content-center {
        position: relative;
        width: 100%;
        height: 73px;
        bottom: 0px;
        left: 0px;
    }
}
@media (max-width:767px){
    .window-body{
        height: 100%;
        max-height: 750px;
        padding-bottom: 20em;
    }
}
</style>
